/**
 * Created by Desarrollo KJ on 20/3/2017.
 */
import { Component, OnInit } from '@angular/core';
import { ApiService } from './../../../services/api.service';
import { ToastyService } from 'ng2-toasty';
import { Router } from '@angular/router';

@Component({
  selector: 'my-edit-perfil',
  template: require('./editPerfil.component.html')
})
export class EditPerfilComponent implements OnInit {

  public formUsuario:any = {
    nombre:'',
    direccion:'',
    correo:'',
    ciudad:'',
  };

  public formClave:any = {
    claveActual:'',
    claveNueva:'',
    claveNueva2:''
  };

  constructor(private _api:ApiService, private toasty:ToastyService, private _router: Router) {
    if (localStorage.getItem('login')) {
      this.formUsuario = JSON.parse(localStorage.getItem('login'));
    }
    else {
      this._router.navigateByUrl('404')
    }
  }

  save(){
      this._api.putUser(this.formUsuario).subscribe(
        result=>{
          console.log(result);
          this.toasty.success('Guardado con exito');
          localStorage.setItem('login', JSON.stringify(this.formUsuario));
        },
        err=>{
          console.log(err);
          let msg = JSON.parse(err._body);
          this.toasty.error(msg.message);
        }
      )
  }

  savePass(){
    if(this.formClave.claveNueva !== this.formClave.claveNueva2){
      this.toasty.error('La nueva clave no coinciden');
      return false
    }

    let user ={
      idUsuario:this.formUsuario.idUsuario,
      claveActual: this.formClave.claveActual,
      claveNueva: this.formClave.claveNueva
    };

    this._api.putPassword(user).subscribe(
      result=>{
        console.log(result);
        this.toasty.success('Guardado con exito');
        localStorage.setItem('login', JSON.stringify(this.formUsuario));
      },
      err=>{
        console.log(err);
        let msg = JSON.parse(err._body);
        this.toasty.error(msg.message);
      }
    )
  }


  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/adminUser/editPerfil/editPerfil.component.ts